import React from "react";

/**
 * Barrierefreiheitserklärung-Seite
 * Enthält Informationen zur Barrierefreiheit der Website gemäß BITV 2.0 und WCAG 2.1
 * Erklärt den aktuellen Stand der Barrierefreiheit und Kontaktmöglichkeiten für Feedback
 */
export default function Barrierefreiheitserklaerung() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0D5C63] via-[#1A7A85] to-[#2D9DA6] py-12">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Barrierefreiheitserklärung
          </h1>
        </div>

        {/* Hauptinhalt */}
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12">
          <div className="prose max-w-none text-gray-700">
            {/* Einleitung */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Erklärung zur Barrierefreiheit für Dienstleistungen</h2>
              <p className="mb-4">
                Im Rahmen unserer Barrierefreiheitserklärung möchten wir Ihnen einen Überblick über den Stand der Vereinbarkeit der unten beschriebenen Dienstleistung(en) mit den Anforderungen der Barrierefreiheit nach gesetzlichen Vorschriften (insbesondere mit dem Barrierefreiheitsstärkungsgesetz – BFSG) geben.
              </p>
            </section>

            {/* Angaben zum Dienstleistungserbringer */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben zum Dienstleistungserbringer</h2>
              <p className="mb-2">Kur- und Reiseverkehr Bad Tabarz kAöR</p>
              <p className="mb-2">Veranstaltungsraum Arenarisquelle</p>
              <p className="mb-2">Schwimmbadweg 10</p>
              <p className="mb-4">99891 Bad Tabarz</p>

              <p className="mb-2">E-Mail: <a href="mailto:info@tabbs.de" className="text-blue-600 hover:underline">info@tabbs.de</a></p>
              <p className="mb-2">Telefon: <a href="tel:0362596730" className="text-blue-600 hover:underline">036259 6730</a></p>

              <p className="mb-2">Link zur Website: <a href="https://arenarisquelle.de/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://arenarisquelle.de/</a></p>
              <p className="mb-4">Link zum Impressum: <a href="https://arenarisquelle.de/impressum" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://arenarisquelle.de/impressum</a></p>
            </section>

            {/* Allgemeine Beschreibung der Dienstleistung */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Allgemeine Beschreibung der Dienstleistung</h2>
              <p className="mb-4">Versenden von Buchungsanfragen für den Raum "Arenarisquelle" über die Webseite arenarisquelle.de</p>
            </section>

            {/* Erläuterungen zur Durchführung der Dienstleistung */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Erläuterungen zur Durchführung der Dienstleistung</h2>
              <p className="mb-4">Über die Webseite arenarisquelle.de informieren wir über den Veranstaltungsraum "Arenarisquelle" und ermöglichen es Ihnen online eine unverbindliche Buchungsanfrage zu übermitteln. Sie können dazu die Verfügbarkeit des Raums im Kalender prüfen und die Daten zu Ihrer Anfrage in einem Formular eingeben.</p>
            </section>

            {/* Stand der Vereinbarkeit mit den Anforderungen */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Stand der Vereinbarkeit mit den Anforderungen</h2>
              <p className="mb-4">
                Wir setzen uns für digitale Barrierefreiheit ein und verfolgen das Ziel, unsere Website so zu gestalten, dass sie für alle Nutzerinnen und Nutzer uneingeschränkt zugänglich ist. Daher arbeiten wir kontinuierlich daran, die Anforderungen des Barrierefreiheitsstärkungsgesetzes (BFSG) und der Verordnung zum Barrierefreiheitsstärkungsgesetz (BFSGV) vollständig umzusetzen.
              </p>
              <p className="mb-4">
                Unserer Webseite setzt die Vorgaben gemäß Web Content Accessibility Guidelines (WCAG) um:
              </p>
              <p className="mb-4">
                <strong>Tastaturbedienbarkeit:</strong> Alle Inhalte und Funktionen sind vollständig über die Tastatur zugänglich, sodass auch Nutzerinnen und Nutzer ohne Maus uneingeschränkt navigieren können.
              </p>
              <p className="mb-4">
                <strong>Vorlesefunktion und ARIA-Attribute:</strong> Unsere Website unterstützt Vorlesefunktionen und ist mit ARIA-Attributen versehen, um die Nutzung mit Screenreadern zu erleichtern.
              </p>
              <p className="mb-4">
                <strong>Optimierte Kontraste und flexible Schriftgrößen:</strong> Wir achten auf ausreichend hohe Farbkontraste für eine bessere Lesbarkeit und ermöglichen es, die Schriftgröße individuell anzupassen, um den unterschiedlichen Bedürfnissen gerecht zu werden.
              </p>
              <p className="mb-4">
                Insoweit Farben zur Vermittlung relevanter Informationen genutzt werden, wird diese Informationen auch in schriftlicher Weise kommuniziert.
              </p>
            </section>

            {/* Feedbackmöglichkeit zur Meldung von Barrieren */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Feedbackmöglichkeit zur Meldung von Barrieren</h2>
              <p className="mb-2">
                Wenn Ihnen Barrieren beim Zugang zu Inhalten auf unserer Website aufgefallen sind, können Sie uns gern einen Hinweis geben:
              </p>
              <p className="mb-4">E-Mail: <a href="mailto:info@tabbs.de" className="text-blue-600 hover:underline">info@tabbs.de</a></p>
            </section>

            {/* Zuständige Marktüberwachungsbehörde */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Zuständige Marktüberwachungsbehörde</h2>
              <p className="mb-2">Marktüberwachungsstelle der Länder für die Barrierefreiheit von Produkten und Dienstleistungen (MLBF)</p>
              <p className="mb-2">c/o Ministerium für Arbeit, Soziales, Gesundheit und Gleichstellung Sachsen-Anhalt</p>
              <p className="mb-2">Postfach 39 11 55</p>
              <p className="mb-4">39135 Magdeburg</p>

              <p className="mb-2">Telefon: <a href="tel:+493915676970" className="text-blue-600 hover:underline">+ 49 (0) 391 567 6970</a></p>
              <p className="mb-4">E-Mail: <a href="mailto:mlbf@ms.sachsen-anhalt.de" className="text-blue-600 hover:underline">mlbf@ms.sachsen-anhalt.de</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
